export enum DataHooks {
  ROOT = 'breadcrumbs-root',
}
export enum BreadcrumbsItemId {
  HOME = 'home',
  SERVICE_LIST = 'service-list',
  CURRENT = 'current',
}